export const FEATURE_DEMO_CHANNEL_URL = 'T025A2121/B0A4Q7AEYQ2/s0bGPbidWQfbYn3BZrAGiJ43'; // #access-request-feature-demo
export const PURCHASED_CHANNEL_URL = 'T025A2121/B0A5JBK107J/zmlz5ddVZILqL8rfYbBVr8u1'; // #access-request-purchased
export const QUICKBOOKS_PRO_TRIAL_UPGRADE_CHANNEL_URL = 'T025A2121/B0BBA29C37G/gSs0jMJBtk2t281GIIEoqnij'; // #quickbooks-pro-trial-upgrade
